import template from './role-management.html';
import controller from './role-management.controller';

let roleManagementComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default roleManagementComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/role-management/role-management.component.js